import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { Text } from 'pixi.js';
import { AnimationContents } from '../../../AnimationContents';
import { UIConstants } from '../../Constants/UIConstants';

export class UILivesController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('UIGasController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            modelWatch: {
                currentGas: (value: number) => {
                    this.updateLives();
                },
            },
        };
    }

    protected onInitialize(): void {
        this.updateLives();
    }

    protected updateLives(){
        for(let i = 0; i < 5; i++){
            this.gotoAndStopByQuery("life" + i, (this.$model.currentGas-1) < i ? 1: 0)
        }
    }
}
